import { motion } from "framer-motion";
import { useAuth } from "@/components/auth/AuthProvider";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export function WelcomeSection() {
  const { user } = useAuth();
  const userName = user?.email?.split('@')[0] || 'bruker';

  return (
    <Card className="overflow-hidden">
      <CardHeader className="space-y-1 p-4 md:p-6">
        <CardTitle 
          className="text-xl md:text-2xl font-bold break-words"
          tabIndex={0}
          aria-label={`Velkommen ${userName}`}
        >
          Velkommen, {userName}!
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4 md:p-6">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="space-y-4"
        >
          <p 
            className="text-sm md:text-base text-muted-foreground max-w-prose break-words"
            tabIndex={0}
          >
            Dette er din personlige dashboard hvor du kan få oversikt over dine aktiviteter og ressurser.
          </p>
          <div 
            className="text-xs md:text-sm text-muted-foreground space-y-2"
            aria-label="Personvernsinformasjon"
          >
            <p className="flex items-center gap-2">
              <span>🔒</span>
              <span>Dine data er sikret og kryptert</span>
            </p>
            <p className="flex items-center gap-2">
              <span>📱</span>
              <span>Tilgjengelig på alle enheter</span>
            </p>
            <p className="flex items-center gap-2">
              <span>♿</span>
              <span>Optimalisert for tilgjengelighet</span>
            </p>
          </div>
        </motion.div>
      </CardContent>
    </Card>
  );
}